<template>
  <div
    v-if="sortedFlows.length"
    class="approvals-list w-100"
    :class="{ 'approvals-list-in-approval-process pt-8': inApprovalProcess }"
  >
    <div
      v-if="!inApprovalProcess"
      class="approvals-list-or-divider d-flex align-center ga-2 px-4 my-6"
      aria-hidden="true"
    >
      <div class="approvals-list-or-line flex-grow-1" />
      <span class="text-caption text-textLight font-weight-medium">OR</span>
      <div class="approvals-list-or-line flex-grow-1" />
    </div>

    <div class="text-h1 text-textDarkest px-8 py-4 d-flex flex-column ga-2">
      Review Existing Approvals
      <p
        v-if="inApprovalProcess"
        class="text-body-1 text-textDark mb-0"
      >
        <span class="font-weight-bold text-textDark">{{ jobProfileTitle }}</span>
        is in an approval flow and cannot be edited.
      </p>
    </div>

    <ApprovalsListItem
      v-for="flow in sortedFlows"
      :key="flow.ulid"
      :flow="flow"
      :templates="templates"
      @click="handleFlowClick"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ApprovalsListItem from '@/components/jobProfiles/editor/ApprovalsListItem.vue';
import { sortApprovalFlowsByDateDesc } from '@/helpers/approvalFlows';

const props = defineProps({
  flows: {
    type: Array,
    default: () => [],
  },
  templates: {
    type: Array,
    default: () => [],
  },
  inApprovalProcess: {
    type: Boolean,
    default: false,
  },
  jobProfileTitle: {
    type: String,
    default: 'job profile',
  },
});

const emit = defineEmits(['flow-click']);

const sortedFlows = computed(() => sortApprovalFlowsByDateDesc(props.flows));

const handleFlowClick = (flow) => {
  emit('flow-click', flow);
};
</script>

<style scoped lang="less">
.approvals-list-or-line {
  border-top: 1px solid @stroke-default;
}
</style>
